<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:00em; padding-top:15px;">This book is about the author, who grew up in Cheshire, in a family of ten, his early years were quite shy; this left him as he got older especially when leaving school and starting work.</p>
<p style="text-indent:00em; padding-top:15px;">After he married and joined the Territorial Army gained confidence and later in life ran a successful butcher’s business. Only once retired began to put his past life down, when family and friends read his first manuscript, then decided to write <em>Baz</em> with the backing of his wife, who has supported him through his married life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?131fcfe0